<template>
	<article
		class="d-frontpage"
		:class="{
			'd-frontpage--no-footer-gap': !hasFooterGap,
		}"
	>
		<FrontpageHeader
			:intro="intro"
			:spot="spot"
			:spot-fallback="spotFallback"
		/>

		<ScopedColorTheme class="w-full px-layout-margin" theme="blue">
			<FrontpageFocus
				v-if="focus && focus.items && focus.items.length"
				class="mt-xl/v"
				:no-bottom-line="expertsLast"
				v-bind="focus"
			/>

			<FrontpageCards
				v-if="themes && themes.items && themes.items.length"
				class="mt-xl/v"
				variant="green"
				v-bind="themes"
			/>
			<FrontpageVideo
				v-if="videoSpot"
				v-bind="videoSpot"
				class="mt-xl/v"
			/>

			<FrontpageHtmlVideo
				v-if="videoSpot"
				v-bind="videoSpot"
				class="mt-xl/v"
			/>

			<FrontpageCards
				v-if="relatedContent"
				v-bind="relatedContent.content"
				class="mt-xl/v"
				variant="teal"
			/>

			<FrontpageExperts
				v-if="
					experts &&
					experts.content &&
					experts.content.items &&
					experts.content.items.length
				"
				class="mt-xl/v"
				:block="experts"
			/>
		</ScopedColorTheme>
	</article>
</template>

<script>
import ScopedColorTheme from '~/components/main/ScopedColorTheme';
import FrontpageHeader from '~/components/main/FrontpageHeader';
import FrontpageFocus from '~/components/main/FrontpageFocus';
import FrontpageCards from '~/components/main/FrontpageCards';
import FrontpageExperts from '~/components/main/FrontpageExperts';
import FrontpageVideo from '~/components/main/FrontpageVideo';
import FrontpageHtmlVideo from '~/components/main/FrontpageHtmlVideo';

export default {
	name: 'MainFrontpage',

	components: {
		ScopedColorTheme,
		FrontpageHeader,
		FrontpageFocus,
		FrontpageExperts,
		FrontpageHtmlVideo,
		FrontpageVideo,
		FrontpageCards,
	},

	inheritAttrs: false,

	props: {
		intro: Object,
		spot: Object,
		relatedContent: {
			type: Object,
			default: null,
		},
		areas: {
			type: Object,
			default: null,
		},
		focus: {
			type: Object,
			default: null,
		},
		themes: {
			type: Object,
			default: null,
		},
		experts: {
			type: Object,
			default: null,
		},
		videoSpot: {
			type: Object,
			default: null,
		},
		spotFallback: {
			type: Object,
			default: null,
		},
	},

	computed: {
		expertsLast() {
			if (
				this.focus &&
				!this.themes &&
				!this.experts?.content?.items?.length
			) {
				return true;
			}
			return false;
		},
		lastBlockIsGrayBlock() {
			if (this.focus && !this.themes) {
				return true;
			}
			return !!this.experts?.content?.items?.length;
		},

		hasFooterGap() {
			if (this.lastBlockIsGrayBlock) {
				return false;
			}

			return true;
		},
	},
};
</script>
